import { IAuth } from '@/modules/auth/types';
import { IGeneral } from '@/shared/types';

export const farmSizeList: IAuth.IFarmSizeProps[] = [
  {
    label: 'small-grower',
    value: '<50',
    range: {
      hectars: '<50',
      acres: '<150',
    },
  },
  {
    label: 'medium-grower',
    value: 'Medium 50 - 300',
    range: {
      hectars: '50-300',
      acres: '150-750',
    },
  },
  {
    label: 'large-grower',
    value: 'Large 300 - 1000',
    range: {
      hectars: '300-1,000',
      acres: '750-2,500',
    },
  },
  {
    label: 'Enterprise',
    value: '+1000',
    range: {
      hectars: '1,000+',
      acres: '2,500+',
    },
  },
  {
    label: 'not-grower',
    value: 'Affiliate',
  },
];

export const CropsList: IGeneral.NameIdPair[] = [
  { id: 0, name: 'Berries & Grapes' },
  { id: 1, name: 'Beverage (e.g coffee)' },
  { id: 2, name: 'Citrus' },
  { id: 3, name: 'Cereals/Grains' },
  { id: 4, name: 'Fibers' },
  { id: 5, name: 'Forage Crops' },
  { id: 6, name: 'Legumes/Pulses' },
  { id: 7, name: 'Medicinal and Aromatic' },
  { id: 8, name: 'Nuts' },
  { id: 9, name: 'Oilseeds' },
  { id: 10, name: 'Ornamental' },
  { id: 11, name: 'Specialty Crops' },
  { id: 12, name: 'Spices & Herbs' },
  { id: 13, name: 'Stone Fruits' },
  { id: 14, name: 'Tropical & Exotics' },
  { id: 15, name: 'Vegetables' },
  { id: 16, name: 'Other Fruits' },
];

export const interestList: IGeneral.NameIdPair[] = [
  { id: 0, name: 'Workers Attendance & Productivity' },
  { id: 1, name: 'Inventory Levels & Dispatch Requests' },
  { id: 2, name: 'Field Operations Scheduling & Assignment' },
  { id: 3, name: 'Worker Payroll' },
  { id: 4, name: 'Farm Costs & Profitability' },
  { id: 5, name: 'Agronomic Insights Powered by AI' },
];

export const toggleItemInList = (list: string[], item: string): string[] => {
  return list?.includes(item)
    ? list.filter((i) => i !== item)
    : [...list, item];
};

export const employeesNumberList: IGeneral.NameIdPair[] = [
  { id: 0, name: '0' },
  { id: 1, name: '1 - 5' },
  { id: 2, name: '5 - 10' },
  { id: 3, name: '10 - 20' },
  { id: 4, name: '20 - 50' },
  { id: 5, name: '+50' },
];
